import { ChevronRightIcon } from '@chakra-ui/icons';
import { Button, Flex, Heading, Image, Text } from '@chakra-ui/react';
import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import Link from '../../Link/Link';
//
const CardSlice = (props: CardSliceType) => {
  const { slice } = props;
  return (
    <Flex
      mt={{ base: '60px', lg: '80px' }}
      flexDir='column'
      gridGap='60px'
      pb={{ base: 10, lg: 12 }}
    >
      {slice.items.map((item, index) => (
        <Flex
          px='12px'
          justify='space-between'
          gridGap='60px'
          flexDir={{ base: 'column-reverse', md: 'row' }}
          key={index}
          pb={{ base: '60px', md: '20px' }}
          borderBottom={index !== slice.items.length - 1 && '1px solid'}
          borderBottomColor='aliceblue.200'
        >
          <Flex flexDir='column' gridGap='20px'>
            <Flex flexDir='column' gridGap='20px' maxW='500px'>
              <Heading as='h2' size='h2' fontWeight='700'>
                {item.card_title}
              </Heading>
              <Text>{item.card_body}</Text>
              <Flex gridGap='20px' flexWrap='wrap'>
                {item.live_demo_button_label && (
                  <Link to={item.live_demo_button_url}>
                    <Button variant='blueHollowTint' p='12px 20px'>
                      {item.live_demo_button_label}
                    </Button>
                  </Link>
                )}
                {item.read_more_button_label && (
                  <Link to={item.read_more_button_url}>
                    <Flex
                      gridGap='8px'
                      align='center'
                      color='pdftron'
                      _hover={{ color: 'blue.500' }}
                    >
                      <Text whiteSpace='nowrap' color='inherit'>
                        {item.read_more_button_label}
                      </Text>
                      <ChevronRightIcon color='inherit' />
                    </Flex>
                  </Link>
                )}
              </Flex>
            </Flex>
          </Flex>
          <Flex mx={{ base: '32px', md: '0' }} maxW='428px' maxH='448px'>
            <Image
              src={item.card_image.url}
              w='100%'
              h='100%'
              objectFit='contain'
              draggable={false}
              alignSelf='center'
              alt={item.card_image.alt}
            />
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export type CardSliceType = SliceComponentProps<{
  id: string;
  items: {
    card_body: string;
    card_image: {
      url?: string;
      alt?: string;
    };
    card_title?: string;
    live_demo_button_label?: string;
    live_demo_button_url?: string;
    read_more_button_label?: string;
    read_more_button_url?: string;
  }[];
  slice_type: string;
}>;

export default CardSlice;
